module.exports = "mutation sendToEConsult($adviceRequestId:String!){sendToEConsult(adviceRequestId:$adviceRequestId)}"